export const hasMitIdApp = () => {};

export const handleMitIDAppSwitch = () => {};
